import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Drawer } from 'antd';

import { Header, Sidebar } from '../index';
import { SidebarContent } from '../Sidebar/Sidebar';
import { useI18n } from '../../i18n';

const COLLAPSE_KEY = 'wm-sidebar-collapsed';

export const CustomLayout = ({ route, children }) => {
  const { pathname } = useLocation();
  const { t } = useI18n();
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(COLLAPSE_KEY) === '1');
  const [mobileOpen, setMobileOpen] = useState(false);

  const onCollapse = () => {
    setCollapsed(prev => {
      localStorage.setItem(COLLAPSE_KEY, prev ? '0' : '1');
      return !prev;
    });
  };

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0 });
  }, [pathname]);

  const crumbs = route?.crumbs ?? [];
  const pageTitle = crumbs.length ? t(crumbs[crumbs.length - 1].key) : '';

  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} · W&M` : 'W&M';
  }, [pageTitle]);

  return (
    <div className={`wm-shell${collapsed ? ' wm-shell--collapsed' : ''}`}>
      <Sidebar collapsed={collapsed} onCollapse={onCollapse} />
      <Drawer
        placement='left'
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        width={272}
        closable={false}
        rootClassName='wm-mobile-nav'
      >
        <SidebarContent onNavigate={() => setMobileOpen(false)} />
      </Drawer>
      <div className='wm-main'>
        <Header onOpenMobileNav={() => setMobileOpen(true)} crumbs={crumbs} />
        <main className='wm-content' id='main'>
          <div className='wm-page' key={pathname}>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};
